module.exports = __webpack_public_path__ + "fonts/ZhenyanGB.1583afec.TTF";